import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Spinner from "./Spinner";
import ReactTimeAgo from "react-time-ago";

const Blogs = () => {
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    fetch("https://iblog-connect.vercel.app/blogs/post")
      .then((response) => response.json())
      .then((posts) => {
        setPosts(posts.posts);
      })
      .catch((error) => {
        console.error("Error fetching posts:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const trimString = (summary) => {
    return summary.length > 225 ? `${summary.substring(0, 225)}...` : summary;
  };

  const formatDate = (date) => {
    const now = new Date();
    const diff = now - date;
    const days = Math.floor(diff / (24 * 60 * 60 * 1000));

    if (days >= 1) {
      // For longer durations, display "posted on"
      return `posted on ${date.toDateString()}`;
    } else {
      // For shorter durations, use ReactTimeAgo
      return (
        <>
          posted <ReactTimeAgo date={date} locale="en-US" timeStyle="twitter" />
          's ago
        </>
      );
    }
  };

  return (
    <div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div>
          {posts?.map((post) => {
            const { _id, title, summary, cover, createdAt, author } = post;
            const createdAtDate = new Date(createdAt);
            return (
              <div key={_id} className="blogs">
                <div className="posts-container">
                  <div className="img-container">
                    <Link to={`/post/${_id}`}>
                      <img className="post-img" src={cover} alt="post-img" />
                    </Link>
                  </div>
                  <div className="post-content">
                    <Link to={`/post/${_id}`}>
                      <h2 className="post-title">{title}</h2>
                    </Link>
                    <p className="info">
                      <a href="/">{author?.username}</a>
                      <time>{formatDate(createdAtDate)}</time>
                    </p>
                    <p className="post-desc">{trimString(summary)}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Blogs;
